const VIDEO_ID = /^[A-Za-z0-9_-]{11}$/;

export function parseYouTubeURL(value) {
  if (typeof value !== 'string' || value.length > 2048) throw new Error('Paste a YouTube video link.');
  let url;
  try { url = new URL(value.trim()); } catch { throw new Error('Paste the complete https:// YouTube video link.'); }
  if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password || url.port) throw new Error('Use a regular YouTube video link.');
  const host = url.hostname.toLowerCase(), path = url.pathname.split('/').filter(Boolean);
  let id;
  if (host === 'youtu.be' && path.length === 1) id = path[0];
  else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com'].includes(host)) {
    if (url.pathname === '/watch') id = url.searchParams.get('v');
    else if (path.length === 2 && ['embed', 'shorts', 'live'].includes(path[0])) id = path[1];
  } else if (['youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host) && path.length === 2 && path[0] === 'embed') id = path[1];
  if (!VIDEO_ID.test(id ?? '')) throw new Error('That link does not identify a YouTube video. Use a watch, share, Shorts, or embed link.');
  const rawTime = url.searchParams.get('t') ?? url.searchParams.get('start') ?? new URLSearchParams(url.hash.slice(1)).get('t') ?? '0';
  let startTime = 0;
  if (/^\d+(?:\.\d+)?$/.test(rawTime)) startTime = Number(rawTime);
  else {
    const match = /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/.exec(rawTime);
    if (match && match[0]) startTime = Number(match[1] ?? 0) * 3600 + Number(match[2] ?? 0) * 60 + Number(match[3] ?? 0);
  }
  startTime = Math.min(8 * 3600, Math.max(0, startTime));
  return { id, url: `https://www.youtube.com/watch?v=${id}`, startTime };
}

export function youTubeErrorMessage(code) {
  if (code === 100) return 'This YouTube video is unavailable, private, or has been removed.';
  if (code === 101 || code === 150) return 'The owner does not allow this video to play in embedded players. Choose another tutorial.';
  if (code === 153) return 'YouTube could not identify this website. Allow the site referrer in your browser privacy settings and try again.';
  if (code === 2) return 'YouTube could not recognize that video link.';
  return 'YouTube could not play this video. Check your connection or choose another tutorial.';
}
